import React, { useMemo } from 'react'
import { DarkTheme, DefaultTheme, LinkingOptions, NavigationContainer } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import { Appearance, Platform } from 'react-native'
import { navigationRef, useBackButtonHandler } from "./navigation-utilities"
import { StartScreen, QuestionDetailScreen, ResultScreen, HelpButton, BackButton } from '../screens'
import { color } from '../theme'
import { translate } from '../i18n'
import { PostHogAutocaptureOptions, PostHogOptions, PostHogProvider } from 'posthog-react-native'
import JalaAnalyticInstance from '../utils/jala-analytic'
import { canExit } from "./app-navigator"

interface NavigationProps extends Partial<React.ComponentProps<typeof NavigationContainer>> {}

export type QuizNavigatorParamList = {
    'Quiz.Start': undefined,
    'Quiz.Detail': undefined,
    'Quiz.Result': undefined,
}

export const QuizStart = {
  index: 0,
  routes: [
    { name: 'Quiz.Start', state: { index: 0, routes: [{ name: 'Quiz.Start' }] } }
  ]
};

const Stack = createStackNavigator<QuizNavigatorParamList>()

const linking: LinkingOptions<any> = {
  prefixes: ['jala://'],
}


export const QuizNavigator = (props: NavigationProps) => {
    const colorScheme = "light" || Appearance.getColorScheme()
    useBackButtonHandler(canExit)

    const autoCapture = useMemo<boolean|PostHogAutocaptureOptions>(() => ({
      captureTouches: false
    }), [])

    const postHogOptions = useMemo<PostHogOptions>(() => ({
      persistence: Platform.OS === 'web' ? "memory" : "file"
    }), [])

    return (
      <NavigationContainer
        ref={navigationRef}
        theme={colorScheme === "dark" ? DarkTheme : DefaultTheme}
        linking={linking}
        {...props}
      >
        <PostHogProvider
          client={JalaAnalyticInstance.postHog}
          autocapture={autoCapture}
          options={postHogOptions}
        >
          <Stack.Navigator
            screenOptions={{
              headerShown: false,
              headerBackTitleVisible: false,
              headerTitleAlign: "left",
              headerTitleContainerStyle: { marginLeft: 0 },
              cardStyle: { flex: 1 },
            }}
            initialRouteName="Quiz.Start"
          >
            <Stack.Screen name="Quiz.Start" component={StartScreen} />
            <Stack.Screen
              name="Quiz.Detail"
              component={QuestionDetailScreen}
              options={({ navigation }) => ({
                headerTitle: translate("common.back"),
                headerShown: true,
                headerShadowVisible: false,
                headerStyle: { backgroundColor: color.primary },
                headerTintColor: color.palette.white,
                headerLeft(props) {
                  return <BackButton {...props} />
                },
                headerRight(props) {
                  return <HelpButton />
                },
              })}
            />
            <Stack.Screen name="Quiz.Result" component={ResultScreen} />
          </Stack.Navigator>
        </PostHogProvider>
      </NavigationContainer>
    )
}

QuizNavigator.displayName = "QuizNavigator"
